/**
 * Acceso al carro desde la cabecera, con el numero de unidades.
 *
 * Es un `<Link>` y no un boton con panel colgante: el carro es una pantalla con
 * su propia URL, se puede compartir entre pestanas y volver atras. Un panel
 * flotante habria hecho lo mismo con mas piezas.
 *
 * El numero no se anuncia por lector de pantalla cada vez que cambia —seria un
 * grito por cada clic en un listado—: quien agrega ya recibe la confirmacion
 * del propio boton. Aca el conteo viaja en el texto accesible del enlace.
 */
import { Link } from 'react-router-dom';

import { useCarro } from '../../contexto/carro-contexto';
import { rutas } from '../../utilidades/rutas';
import { Icono } from '../comunes/Icono';

export function IndicadorCarro() {
  const { unidades } = useCarro();

  return (
    <Link
      className="btn-icono carro-acceso"
      to={rutas.carro()}
      aria-label={
        unidades === 0
          ? 'Ver el carro, vacio'
          : `Ver el carro, ${unidades} ${unidades === 1 ? 'unidad' : 'unidades'}`
      }
      title="Ver el carro"
    >
      <Icono nombre="carro" />
      {unidades > 0 ? (
        <span className="carro-globo" aria-hidden="true">
          {unidades > 99 ? '99+' : unidades}
        </span>
      ) : null}
    </Link>
  );
}
